@if (config) {
  <powerbi-paginated-report [embedConfig]="config" cssClassName="full-dimensions" />
} @else {
  @if (error) {
    <span>Unable to load powerBI</span>
  } @else {
    <span>loading..</span>
  }
}
